export enum UserRoleEnum {
  Admin = 1,
  User = 2,
  Perito = 3,
}
